export const enum PromoRoutesEnum {
  root = '/',
  banners = '/banners',
  signboard = '/signboard',
  videoConnection = '/video-connection',
  listSignBoardsContractors = '/list-sign-boards-contractors',
  listSignBoardsSortingCenters = '/list-sign-boards-sorting-centers',
  listELockContractors = '/list-elock-contractors',
  eLock = '/elock',
  conferences = '/conferences',
  rating = '/rating',
  apps = '/apps',
  contractors = '/contractors',
  privacyPolicy = 'privacy-policy',
  bankingServices = '/banking-services',
  simplifiedConditions = '/simplified-conditions',
  knowledgeBase = '/knowledge-base',
  map = '/map',
}

export const enum PromoGeRoutesEnum {
  root = '/',
  apps = '/apps',
  login = '/login-page',
}

export const enum AuthRoutesEnum {
  login = '/login',
  registration = '/registration',
}
export const enum MapRoutesEnum {
  map = '/map',
  orders = '/map/orders',
}

export const enum LKRoutesEnum {
  orders = '/lk/orders',
  orderCreate = '/lk/orders/create',
  orderPayment = '/lk/orders/payment',
  pvz = '/lk/pvz',
  tickets = '/lk/tickets',
  ticketCreate = '/lk/tickets/create',
  employees = '/lk/employees',
  addEmployee = '/lk/employees/add',
  editEmployee = '/lk/employees/edit',
  profile = '/lk/profile',
  editRequisites = '/lk/profile/editRequisites',
  editPassport = '/lk/profile/editPassport',
  editContact = '/lk/profile/editContact',
}
